<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'user_agent',
                label: 'User Agent',
                sortable: true,
                searchable: true,
            },
            {
                value: 'description',
                label: 'Description',
                sortable: true,
                searchable: true,
            },
            {
                value: 'created_at',
                label: 'Created',
                filter: 'localDateTime',
                sortable: true,
                searchable: false,
            },
        ]"
        :defaultSort="defaultSort"
        :defaultDir="defaultDir"
        :title="'Products'"
        :model="'products'"
        :createText="'Create Product'"
        :options="['editable', 'deletable']"
        data-test-id="products-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import SortDirections from '@/constants/sort-directions'

export default {
    components: {
        IndexTable,
    },
    data() {
        return {
            defaultSort: 'created_at',
            defaultDir: SortDirections.DESC,
        }
    },
}
</script>
